module.exports = __webpack_public_path__ + "static/media/main_slider_3.261cb7c0.jpg";